import { hasFileExtension } from 'shared/src/utils/hasFileExtension';

const pdfFileExtensions = ['.pdf'];

export const isPdf = (url: string) => {
  return hasFileExtension(url, pdfFileExtensions);
};
